import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { UrlParser } from 'Roblox';
import loadScript from '../utils/loadScript';
import { veriffInContextScriptUrl, veriffIframeDomain } from '../constants/urlConstants';
import getSessionUrl from '../services/ageVerificationService';
import { STARTED, FINISHED } from '../constants/veriffStatus';
import VeriffThankYouPage from './VeriffThankYouPage';

function Veriff({ translate }) {
  const [veriffStatus, setVeriffStatus] = useState(STARTED);
  const sessionToken = UrlParser.getParameterValueByName('sessionid', false);
  const identifier = UrlParser.getParameterValueByName('identifier', false);

  useEffect(() => {
    (async () => {
      let src = `${veriffIframeDomain}/${sessionToken}`;

      if (identifier) {
        const veriffUrl = await getSessionUrl(identifier).catch(() => {
          return null;
        });

        if (veriffUrl) {
          src = veriffUrl;
        }
      }

      const isScriptLoaded = await loadScript(veriffInContextScriptUrl);
      const { createVeriffFrame, MESSAGES } = isScriptLoaded && window.veriffSDK;
      createVeriffFrame({
        url: src,
        onEvent: msg => {
          switch (msg) {
            case MESSAGES.FINISHED:
              setVeriffStatus(FINISHED);
              break;
            case MESSAGES.CANCELED:
            case MESSAGES.STARTED:
            default:
              break;
          }
        }
      });
    })();
  }, [sessionToken, identifier]);

  return (
    <React.Fragment>
      {veriffStatus !== FINISHED && <div id='veriff-root' />}
      {veriffStatus === FINISHED && <VeriffThankYouPage translate={translate} />}
    </React.Fragment>
  );
}

Veriff.propTypes = {
  translate: PropTypes.func.isRequired
};

export default Veriff;
